import { navFunctions } from './menu';

document.addEventListener('DOMContentLoaded', () => {
    navFunctions();
});